export default {"src":"/_next/static/media/vibe.4f6b6bd6.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};